import { gql } from "@apollo/client";
import { COURSE_FRAGMENT, SERIES_FRAGMENT, PLAN_FRAGMENT } from "../fragments";

export const ADD_CART_ITEM = gql`
  ${COURSE_FRAGMENT}
  ${SERIES_FRAGMENT}
  ${PLAN_FRAGMENT}
  mutation AddCartItem(
    $itemableType: CartItemable!
    $itemableId: Int!
    $cartUuid: String
  ) {
    cartItemAdd(
      input: {
        itemableType: $itemableType
        itemableId: $itemableId
        cartUuid: $cartUuid
      }
    ) {
      discountAmount
      subTotalAmount
      nsdcAmount
      totalAmount
      taxAmount
      uuid
      cartItems {
        uuid
        discountAmount
        subTotalAmount
        totalAmount
        itemable {
          __typename
          ...CourseFragment
          ...SeriesFragment
          ...PlanFragment
        }
        nsdcIncluded
        nsdcPrice
        nsdcOrignalPriceCart
      }
      coupon {
        code
        description
        discount
      }
    }
  }
`;

export const LINK_CART_TO_USER = gql`
  ${COURSE_FRAGMENT}
  ${SERIES_FRAGMENT}
  ${PLAN_FRAGMENT}
  mutation LinkCartToUser($cartUuid: String!) {
    linkCartToUser(input: { cartUuid: $cartUuid }) {
      uuid
      discountAmount
      subTotalAmount
      nsdcAmount
      totalAmount
      taxAmount
      cartItems {
        uuid
        discountAmount
        subTotalAmount
        totalAmount
        itemable {
          __typename
          ...CourseFragment
          ...SeriesFragment
          ...PlanFragment
        }
        nsdcIncluded
        nsdcPrice
        nsdcOrignalPriceCart
      }
      coupon {
        code
        description
        discount
      }
    }
  }
`;

export const CREATE_RAZORPAY_ORDER = gql`
  mutation CreateRazorPayOrder($cartUuid: String!) {
    razorpayOrderCreate(input: { cartUuid: $cartUuid }) {
      id
      amountDue
    }
  }
`;

export const CREATE_PLAN_ORDER = gql`
  mutation CreatePlanOrder($input: StartPlanInput!) {
    startPlan(input: $input) {
      id
      title
      price
    }
  }
`;

export const REMOVE_COUPON = gql`
  ${COURSE_FRAGMENT}
  ${SERIES_FRAGMENT}
  ${PLAN_FRAGMENT}
  mutation RemoveCoupon($cartUuid: String!) {
    couponRemove(input: { cartUuid: $cartUuid }) {
      uuid
      discountAmount
      subTotalAmount
      nsdcAmount
      totalAmount
      taxAmount
      cartItems {
        uuid
        discountAmount
        subTotalAmount
        totalAmount
        itemable {
          __typename
          ...CourseFragment
          ...SeriesFragment
          ...PlanFragment
        }
        nsdcIncluded
        nsdcPrice
        nsdcOrignalPriceCart
      }
      coupon {
        code
        description
        discount
      }
    }
  }
`;

export const APPLY_COUPON = gql`
  ${COURSE_FRAGMENT}
  ${SERIES_FRAGMENT}
  ${PLAN_FRAGMENT}
  mutation ApplyCoupon($couponCode: String!, $cartUuid: String!) {
    couponApply(input: { couponCode: $couponCode, cartUuid: $cartUuid }) {
      uuid
      discountAmount
      subTotalAmount
      nsdcAmount
      totalAmount
      taxAmount
      cartItems {
        uuid
        discountAmount
        subTotalAmount
        totalAmount
        itemable {
          __typename
          ...CourseFragment
          ...SeriesFragment
          ...PlanFragment
        }
        nsdcIncluded
        nsdcPrice
        nsdcOrignalPriceCart
      }
      coupon {
        code
        description
        discount
      }
    }
  }
`;

export const REMOVE_CART_ITEM = gql`
  ${COURSE_FRAGMENT}
  ${SERIES_FRAGMENT}
  ${PLAN_FRAGMENT}
  mutation RemoveCartItem($cartItemUuid: String!) {
    cartItemRemove(input: { cartItemUuid: $cartItemUuid }) {
      uuid
      discountAmount
      subTotalAmount
      nsdcAmount
      totalAmount
      taxAmount
      cartItems {
        uuid
        discountAmount
        subTotalAmount
        totalAmount
        itemable {
          __typename
          ...CourseFragment
          ...SeriesFragment
          ...PlanFragment
        }
        nsdcIncluded
        nsdcPrice
        nsdcOrignalPriceCart
      }
      coupon {
        code
        description
        discount
      }
    }
  }
`;

export const VERIFY_PAYMENT = gql`
  ${COURSE_FRAGMENT}
  ${SERIES_FRAGMENT}
  ${PLAN_FRAGMENT}
  mutation razorPayVerifyPayment($cartUuid: String!, $rzpOrderId: String!) {
    razorpayVerifyPayment(
      input: { cartUuid: $cartUuid, rzpOrderId: $rzpOrderId }
    ) {
      uuid
      discountAmount
      subTotalAmount
      nsdcAmount
      totalAmount
      taxAmount
      cartItems {
        uuid
        discountAmount
        subTotalAmount
        totalAmount
        itemable {
          __typename
          ...CourseFragment
          ...SeriesFragment
          ...PlanFragment
        }
        nsdcIncluded
        nsdcPrice
        nsdcOrignalPriceCart
      }
      coupon {
        code
        description
        discount
      }
    }
  }
`;

export const RESET_CART = gql`
  mutation resetCart($input: CartClearInput!) {
    cartClear(input: $input) {
      uuid
    }
  }
`;

export const ADD_OR_REMOVE_NSDC_CERTIFICATION_TO_COURSE = gql`
  ${COURSE_FRAGMENT}
  ${SERIES_FRAGMENT}
  ${PLAN_FRAGMENT}
  mutation cartNsdcUpdate($input: NsdcUpdateInput!) {
    cartNsdcUpdate(input: $input) {
      discountAmount
      subTotalAmount
      nsdcAmount
      totalAmount
      taxAmount
      uuid
      cartItems {
        uuid
        discountAmount
        subTotalAmount
        totalAmount
        itemable {
          __typename
          ...CourseFragment
          ...SeriesFragment
          ...PlanFragment
        }
        nsdcIncluded
        nsdcPrice
        nsdcOrignalPriceCart
      }
      coupon {
        code
        description
        discount
      }
    }
  }
`;
